/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ICategoryTileViewProps } from './category-tile';

export default (props: ICategoryTileViewProps) => {
    const { config } = props;
    return (
        <div
            className='category-tile'
            style={{
                backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 100%), url(${config.backgroundImage.src ||
                    config.backgroundImage})`
            }}
        >
            <span className='category-tile__title'>{config.title}</span>
        </div>
    );
};
